import { Route } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { TermAndConditionComponent } from './feature/term-and-condition/term-and-condition.component';
import { PrivacyPolicyComponent } from './feature/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './feature/cookies-policy/cookies-policy.component';
import { Lib404PageNotFoundComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { TirewarrantyPolicy60DayComponent } from './feature/tirewarranty-policy-60-day/tirewarranty-policy-60-day.component';
import { LifeLongWarrantyPolicyComponent } from './feature/life-long-warranty-policy/life-long-warranty-policy.component';

export enum ROUTER_TOKENS {
  TOYO = 'TOYO',
  // HOME = 'home',
  PRODUCTS = 'products',
  PROMOTIONS = 'promotions',
  VIDEOS = 'videos',
  NEWS = 'news',
  ARTICLE = 'article',
  BRANCHES = 'branches',
  ABOUT_US = 'about-us',
  FRANCHISE = 'franchise',
  AFTER_SALE_SERVICE = 'after-sale-service',
  WARRANTY_POLICY = 'warrantyPolicy',
  CONTACT_US = 'contact-us',
  TERM_AND_CONDITION = 'term-and-condition',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIES_POLICY = 'cookies-policy',
  TIRE = 'tire',
  LUBRICANT = 'lubricant',
  BREAK = 'brake',
  GALLERY = 'gallery',
  TIREWARRANTY_POLICY_60_DAY = 'tirewarranty-policy-60-day',
  LIFE_LONG_WARRANTY_POLICY = 'life-long-warranty-policy',
}

export const appRoutes: Route[] = [
  // {
  //   path: '',
  //   redirectTo: ROUTER_TOKENS.HOME,
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: HomeComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'TOYO TIRES Thailand | ยางรถยนต์คุณภาพจากญี่ปุ่น',
      description:
        'เว็บไซต์ทางการของ TOYO TIRES Thailand ครบทั้งข้อมูลสเปก ไซซ์สำหรับเก๋ง กระบะ SUV และ EV เทคโนโลยีญี่ปุ่นเพื่อความเงียบ เกาะถนน และความปลอดภัย ค้นหารุ่นยางที่เหมาะกับสไตล์ขับขี่ เช็กราคา/โปร และศูนย์บริการใกล้คุณได้ทันที | TOYO TIRES Thailand',
      keywords:
        'ยาง toyo,ยาง toyo ราคา,TOYO TIRES Thailand,ยางรถยนต์คุณภาพญี่ปุ่น,เปลี่ยนยางรถยนต์ toyo,ราคายางรถยนต์ toyo',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th',
      publisher: 'TOYO',
    },
  },
  {
    path: ROUTER_TOKENS.TERM_AND_CONDITION,
    component: TermAndConditionComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ | TOYO TIRES Thailand',
      description:
        'เอกสารข้อกำหนดและเงื่อนไขการใช้เว็บไซต์/บริการของ TOYO TIRES ครอบคลุมขอบเขตการใช้งาน สิทธิและหน้าที่ของผู้ใช้ หลักเกณฑ์ทางกฎหมาย ข้อจำกัดความรับผิด และแนวทางการติดต่อ สร้างความโปร่งใสและความมั่นใจในการใช้งานทุกส่วนของเว็บไซต์ | TOYO TIRES Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th/term-and-condition',
      publisher: 'TOYO TIRES',
    },
  },
  {
    path: ROUTER_TOKENS.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'นโยบายความเป็นส่วนตัว | TOYO TIRES Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย เพื่อให้คุณใช้งานเว็บไซต์และบริการของ TOYO TIRES ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | TOYO TIRES Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th/privacy-policy',
      publisher: 'TOYO TIRES',
    },
  },
  {
    path: ROUTER_TOKENS.COOKIES_POLICY,
    component: CookiesPolicyComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'นโยบายคุกกี้ | TOYO TIRES Thailand',
      description:
        'ชี้แจงประเภทคุกกี้ วัตถุประสงค์ด้านฟังก์ชัน การวิเคราะห์ และการโฆษณา อธิบายผลต่อประสบการณ์ผู้ใช้ พร้อมวิธีตั้งค่า/จัดการความยินยอมในเบราว์เซอร์ คุณสามารถปรับเปลี่ยนการยินยอมได้ทุกเมื่อ เพื่อให้การใช้งานเว็บไซต์เหมาะกับความต้องการมากที่สุด | TOYO TIRES Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th/cookies-policy',
      publisher: 'TOYO TIRES',
    },
  },
  {
    path: ROUTER_TOKENS.PRODUCTS,
    loadChildren: () => import('./feature/products/products.routes').then((m) => m.productRoutes),
  },
  {
    path: ROUTER_TOKENS.PROMOTIONS,
    loadChildren: () => import('./feature/promotions/promotions.routes').then((m) => m.promotionsRoutes),
  },
  {
    path: ROUTER_TOKENS.VIDEOS,
    loadChildren: () => import('./feature/videos/videos.routes').then((m) => m.videosRoutes),
  },
  {
    path: ROUTER_TOKENS.NEWS,
    loadChildren: () => import('./feature/news/news.routes').then((m) => m.newsRoutes),
  },
  {
    path: ROUTER_TOKENS.ARTICLE,
    loadChildren: () => import('./feature/article/article.routes').then((m) => m.articleRoutes),
  },
  {
    path: ROUTER_TOKENS.BRANCHES,
    loadChildren: () => import('./feature/branches/branches.routes').then((m) => m.branchesRoutes),
  },
  {
    path: ROUTER_TOKENS.ABOUT_US,
    loadChildren: () => import('./feature/about-us/about-us.routes').then((m) => m.aboutUsRoutes),
  },
  {
    path: ROUTER_TOKENS.GALLERY,
    loadChildren: () => import('./feature/gallery/gallery.routes').then((m) => m.galleryRoutes),
  },
  {
    path: ROUTER_TOKENS.LIFE_LONG_WARRANTY_POLICY,
    component: LifeLongWarrantyPolicyComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'นโยบายการรับประกันตลอดอายุการใช้งาน | TOYO TIRES Thailand',
      description:
        'นโยบายการรับประกันตลอดอายุการใช้งานสำหรับยางรถยนต์ TOYO TIRES ครอบคลุมเงื่อนไขการรับประกัน การดูแลรักษา และข้อจำกัดต่างๆ เพื่อให้คุณมั่นใจในคุณภาพและความทนทานของผลิตภัณฑ์ พร้อมข้อมูลติดต่อสำหรับการขอรับบริการหลังการขาย | TOYO TIRES Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th/life-long-warranty-policy',
      publisher: 'TOYO TIRES',
    },
  },
  {
    path: ROUTER_TOKENS.TIREWARRANTY_POLICY_60_DAY,
    component: TirewarrantyPolicy60DayComponent,
    data: {
      name: ROUTER_TOKENS.TOYO,
      title: 'นโยบายการรับประกัน 60 วัน | TOYO TIRES Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย เพื่อให้คุณใช้งานเว็บไซต์และบริการของ TOYO TIRES ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | TOYO TIRES Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://toyotires.in.th/tirewarranty-policy-60-day',
      publisher: 'TOYO TIRES',
    },
  },
  {
    path: '**',
    component: Lib404PageNotFoundComponent,
  },
];
